export default __webpack_public_path__ + "static/banner-where-to-travel-52136cd73de6707a2ec1a832e743d8fa.jpg";